<script setup>
  import { computed } from 'vue';
  import MapDrawingShapeCircle from '@/components/MapDrawingShapeCircle.vue';
  import MapDrawingShapePolygon from '@/components/MapDrawingShapePolygon.vue';
  import MapDrawingShapePolyline from '@/components/MapDrawingShapePolyline.vue';

  const emit = defineEmits(['shape-selection:click']);

  const props = defineProps({
    shape: {
      type: Object,
      required: true
    },
    drawingManager: {
      type: Object,
      required: true
    }
  });

  const settings = computed(() => {
    return {
      ...props.shape.settings,
      'stroke-width': 10,
      'stroke-opacity': 0,
    };
  });

  const handleShapeSelectionClick = (event) => {
    const id = props.shape.id;
    const payload = {
      id,
      type: 'shape-selection',
    };

    emit('shape-selection:click', payload);
  };

</script>

<template>
  <MapDrawingShapePolyline
    v-if="props.shape.type === 'polyline'"
    @click.prevent="handleShapeSelectionClick"
    :id="props.shape.id"
    :drawingManager="props.drawingManager"
    :points="props.shape.points"
    :shapeClosed="shape.closed"
    class="jwx-map-drawing__shape-selection"
    v-bind="{...settings}"
  />
  <MapDrawingShapeCircle
    v-else-if="props.shape.type === 'circle'"
    @click.prevent="handleShapeSelectionClick"
    :id="props.shape.id"
    :drawingManager="props.drawingManager"
    :points="props.shape.points"
    :radiusDistance="props.shape.settings.radius"
    class="jwx-map-drawing__shape-selection"
    v-bind="{...settings}"
  />
  <MapDrawingShapePolygon
    v-else-if="props.shape.type === 'polygon'"
    @click.prevent="handleShapeSelectionClick"
    :id="props.shape.id"
    :drawingManager="props.drawingManager"
    :points="props.shape.points"
    :shapeClosed="props.shape.closed"
    class="jwx-map-drawing__shape-selection"
    v-bind="{...settings}"
  />
</template>